import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconRewardsSg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={33}
    fill="none"
    viewBox="0 0 34 33"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-rewards-sg_svg__a)"
      d="m4 22.625 1.375-3.75 9.75 9.75L11.375 30 4 22.625Zm-2.875 7.688 2.063-5.625 6.124 6.125-5.624 2.062C3.438 33 3.188 33 3 33c-.563 0-1.063-.188-1.438-.563-.562-.562-.75-1.374-.437-2.124Zm9.25-16.688 10 10c.5.5.688 1.188.563 1.813-.125.687-.625 1.25-1.25 1.437l-2.5.938-11-11 .937-2.5c.188-.626.75-1.063 1.438-1.25a2.011 2.011 0 0 1 1.812.562ZM12.5 11c-.438 0-.875-.125-1.188-.5-.5-.625-.437-1.563.313-2.125a6.77 6.77 0 0 0 2.438-5.25V2.5c0-.813.687-1.5 1.437-1.5.813 0 1.438.688 1.438 1.5v.625c0 2.938-1.25 5.688-3.5 7.563-.313.25-.626.312-.938.312ZM5 5c-1.125 0-2-.875-2-2 0-1.063.938-1.938 2-1.938 1 0 1.938.875 1.938 1.938S6.063 5 5 5Zm26.438 12c.875 0 1.5.688 1.5 1.5 0 .875-.626 1.5-1.438 1.5h-.625c-2.063 0-3.938.938-5.313 2.5-.312.375-.75.5-1.125.5-.312 0-.625-.063-.937-.313a1.558 1.558 0 0 1-.188-2.125c1.875-2.25 4.625-3.562 7.5-3.562h.625Zm-6.125-5c-1.313 1.563-2.75 1.688-3.938 1.813-.875.062-1.313.124-1.813.687-.312.375-.75.5-1.125.5-.312 0-.687-.063-.937-.313a1.558 1.558 0 0 1-.188-2.124c1.313-1.563 2.813-1.688 3.875-1.75.938-.126 1.375-.126 1.875-.75.5-.563.5-1 .438-1.938-.125-1.063-.188-2.563 1.125-4.063C25.938 2.5 27.375 2.375 28.5 2.25c.938-.063 1.313-.125 1.813-.688a1.558 1.558 0 0 1 2.125-.187c.624.563.687 1.5.187 2.125-1.313 1.563-2.813 1.688-3.875 1.75-.938.125-1.375.188-1.875.75-.5.563-.5 1-.438 1.938C26.563 9 26.625 10.5 25.313 12Zm5.625 15c1.125 0 2 .938 1.937 2 0 1-.938 1.938-1.938 1.938A1.947 1.947 0 0 1 29 29c0-1.063.813-2 1.938-2Zm0-18c1.125 0 2 .938 1.937 2 0 1-.938 1.938-1.938 1.938A1.947 1.947 0 0 1 29 11c0-1.063.813-2 1.938-2Z"
    />
    <defs>
      <linearGradient
        id="icon-rewards-sg_svg__a"
        x1={33}
        x2={1}
        y1={1}
        y2={33}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconRewardsSg;
